import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import '../../assets/styles/components/dialog.scss'
// \src\companys\scb\assets\styles\components\dialog.scss
// import closeIcon from '@assets/images/icons/trade_icon_cancel_normal.png'
import { KEY_CODE } from '@/constants/keys.code';
import { getSafe } from '@/helpers/global';
import { SERVICES_RESP as servicesResp } from '@/configurations';
import { logoutAction } from '@/actions/auth';
import { X } from 'react-feather';

class Dialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openContent: false
    }
    this.dialogRef = React.createRef();
  }
  render() {
    const {
      title,
      children,
      isOpen,
      background,
      disableBackgroundColor,
      language,
      theme,
      browser,
      errorCode
    } = this.props;
    const { openContent } = this.state;

    return (
      <React.Fragment>
        <div ref={this.dialogRef} className={classnames('dialog-container', 'theme-' + theme, 'run-on-' + browser)}>
          <div className={classnames('dialog', isOpen && 'dialog--open')}>
            <div className={classnames('dialog-background', !disableBackgroundColor && 'dialog-background-color')} onClick={this.handleClickBackground}
              style={{ background: disableBackgroundColor ? undefined : background }} />
            <div className={classnames('dialog-content', openContent && 'dialog-content--open')}>
              {
                title &&
                <header>
                  <p id='dialog_title'>{getSafe(() => language[title], title)}</p>
                  {errorCode === servicesResp.SESSION_NOT_FOUND
                    ?
                    <span onClick={this.logoutSessionNotFound}>
                      <X />
                    </span>
                    :
                    <span onClick={() => this.props.onClose()}>
                      <X />
                    </span>
                  }
                </header>
              }

              <section>
                {children}
              </section>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }

  logoutSessionNotFound = () => {
    this.props.logoutAction({}, () => { });
    this.props.onClose(() => { });
  }

  handleClickBackground = () => {
    if (this.props.disableBackdropClick) {
      return;
    }
    this.props.onClose();
  }

  handleKeyDown = (event) => {
    if (event.keyCode && event.keyCode === KEY_CODE.ESC_KEY) {
      this.props.onClose();
    }
  }

  componentDidMount() {
    this.dialogRef.current.addEventListener('keydown', this.handleKeyDown);
    setTimeout(() => {
      this.setState({ openContent: true })
    }, 0)
  }

  componentWillUnmount() {
    this.dialogRef.current.removeEventListener('keydown', this.handleKeyDown)
  }
}

Dialog.defaultProps = {
  title: '',
  disableBackdropClick: false,
  disableBackgroundColor: false,
  children: <div style={{ width: '500px', textAlign: 'center' }}>Dialog Content</div>,
  onClose: () => { },
  isOpen: false,
  background: '#151a21',
  errorCode: {}
}

export default connect(
  state => ({
    language: state.app.language,
    theme: state.app.theme,
    browser: state.app.browser
  }),
  dispatch => ({
    logoutAction: (p, c) => dispatch(logoutAction(p, c))
  })
)(Dialog)